// SourceNotes - "What else the documents tell us". Every note cites its
// page. A note Claude wrote stays marked until the owner accepts it (and
// may correct it while accepting); a rejected one is gone from the page.
import React, { useState } from "react";
import { Button, Input, Modal } from "antd";
import { sourceText } from "./glanceModel";

export default function SourceNotes({ notes, canEdit, onReview }) {
  const [editing, setEditing] = useState(null);
  const [draft, setDraft] = useState("");
  if (!notes || !notes.length) return null;
  return (
    <div className="g-cols">
      {notes.map((n, i) => {
        const pending = n.by === "claude" && n.review !== "accepted";
        return (
          <div key={`${n.title}-${i}`}>
            <h3 style={{ marginTop: 0 }}>
              {n.title}
              {pending && <span className="g-badge" title="Written automatically from the cited pages; not yet reviewed">Pending</span>}
              {n.reviewedBy && n.review === "accepted" && <span className="g-badge ok" title={`Accepted by ${n.reviewedBy}`}>reviewed</span>}
            </h3>
            <p>{n.text}</p>
            {sourceText(n.source) && <div className="g-src">Source: {sourceText(n.source)}</div>}
            {canEdit && pending && (
              <div className="g-actions">
                <Button size="small" onClick={() => onReview({ type: "note", index: n.index, decision: "accepted" })}>Accept</Button>
                <Button size="small" onClick={() => { setEditing(n); setDraft(n.text); }}>Edit and accept</Button>
                <Button size="small" danger onClick={() => onReview({ type: "note", index: n.index, decision: "rejected" })}>Reject</Button>
              </div>
            )}
          </div>
        );
      })}
      <Modal open={!!editing} title={editing ? `Correct "${editing.title}"` : ""} okText="Save and accept"
             onCancel={() => setEditing(null)}
             onOk={async () => { await onReview({ type: "note", index: editing.index, decision: "accepted", text: draft }); setEditing(null); }}>
        <Input.TextArea rows={6} value={draft} onChange={(e) => setDraft(e.target.value)} />
      </Modal>
    </div>
  );
}
